import { DispatchItemService } from './../dispatchitem/dispatchitemservice';
import { DispatchState } from './../dispatch-state/dispatch-state';
import { Sendgridservice } from './../_services/sendgridService';
import { Tracking, TrackingCreate } from './../tracking/tracking';
import { Machine } from './../machine/machine';
import { DispatchOrderService } from './dispatch-order-service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DispatchOrder } from './dispatch-order';
import { DatePipe } from '@angular/common';
import { Authenticate } from '../authenticate/authenticate';
import { User } from '../user/user';
import { TrackingService } from '../tracking/trackingservice';
import { ML } from '../comment/ML';
import { FixCat } from '../fixcat/fixcat';
import { Logevent } from '../logevent/logevent';
import { LogEventService } from '../logevent/logeventservice';
import { DispatchItem } from '../dispatchitem/dispatchitem';
import { FixCatService } from '../fixcat/fixcatservice';
import { MachineService } from '../machine/machineService';
import { TicketCreate } from '../ticket/ticket';
import { TicketService } from '../ticket/ticketService';
import { UserService } from '../_services';

@Component({
  selector: 'app-dispatch-order',
  templateUrl: './dispatch-order.component.html',
  styleUrls: ['../machine/machine.component.less', '../app.component.less', './dispatch-order.component.css']
})
export class DispatchOrderComponent implements OnInit {
  //#region "CLASS VARIABLES"
  auth: Authenticate;
  currentUser: User;
  _dispatchOrder: DispatchOrder;
  _machines: Machine[];
  _trackings: Tracking[];
  _date: String;
  _time: String;
  _state: DispatchState;
  _fixcats: FixCat[];
  showAccept = false;
  showReceive = false;
  showReturn = false;
  showAdd = false;
  showRemove = false;
  _today: Date = new Date;
  _history: Logevent[] = [];
  _dispatchItems: DispatchItem[];
  searchquery: String;
  _userRole: string;
  _newMachines: Machine[] = [];
  _newDispatchItems: DispatchItem[] = [];
  _newticket: TicketCreate;
  _userId: number;
  _editnote: boolean = false;
  redirecturl: string;


  //#endregion

  constructor(private activateroute: ActivatedRoute,
    private dispatchorderservice: DispatchOrderService,
    private datePipe: DatePipe,
    private trackingservice: TrackingService,
    private sendgridservice: Sendgridservice,
    private logeventservice: LogEventService,
    private dispatchitemservice: DispatchItemService,
    private fixcatservice: FixCatService,
    private _machineservice: MachineService,
    private ticketservice: TicketService, private userService: UserService,

    private userservice: UserService) { }


  //  PAGE LOAD FUNCTION
  ngOnInit(): void {
    try {
      this.userservice.getCurrentUser().subscribe(response => {
        this.currentUser = response;
        this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
        this._userRole = this.auth.user.role.name;
        this._userId = this.auth.user.id;
        const id = +this.activateroute.snapshot.paramMap.get('id');
        this.fixcatservice.getCats().subscribe(res => { this._fixcats = res });
        this.dispatchorderservice.getDispatchOrder(id).subscribe(resp => {
          this._dispatchOrder = resp;
          this._machines = resp.machines;
          this._trackings = resp.trackings.reverse();
          this._date = this.datePipe.transform(resp.date, "dd-MM-yyyy");
          this._time = this.datePipe.transform(resp.date, 'h:mm:ss a');
          this._state = resp.dispatchstate;
          this._dispatchItems = resp.dispatchitems;
          this._dispatchOrder.note = resp.note;

          // If order is open => show Receive Button and Search Features
          this.setMenu(resp.dispatchstate.id, this.currentUser.privilege);
          this.logeventservice.getLogByDispatchOrder(id).subscribe(resp => this._history = resp.reverse());


        });
      });



    }
    catch { }
  }

  reloadPage(): void {

    this.userservice.getCurrentUser().subscribe(response => {

      //this.getCurrentUser();
      this.currentUser = response;
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      this._userRole = this.auth.user.role.name;
      this._userId = this.auth.user.id;
      const id = +this.activateroute.snapshot.paramMap.get('id');
      this.fixcatservice.getCats().subscribe(res => { this._fixcats = res });
      this.dispatchorderservice.getDispatchOrder(id).subscribe(resp => {
        this._dispatchOrder = resp;
        this._machines = resp.machines;
        this._trackings = resp.trackings.reverse();
        this._date = this.datePipe.transform(resp.date, "dd-MM-yyyy");
        this._time = this.datePipe.transform(resp.date, 'h:mm:ss a');
        this._state = resp.dispatchstate;
        this._dispatchItems = resp.dispatchitems;
        // If order is open => show Receive Button and Search Features
        this.setMenu(resp.dispatchstate.id, this.currentUser.privilege);

        this.logeventservice.getLogByDispatchOrder(id).subscribe(resp => this._history = resp.reverse());
      });
    });
  }


  //  CONFIRM RECEPTION OF ORDER
  receiveOrder() {
    // GET USER SESSION
    this.getCurrentUser();
    //CREATE TRACKING RECORD
    var trk: TrackingCreate = new TrackingCreate;
    var timestamp = new Date();
    trk.date = timestamp;
    trk.trackingstate = 3;
    trk.dispatchorder = this._dispatchOrder.id;
    trk.user = this.currentUser.id;
    trk.shipper = this.currentUser.firstname + " " + this.currentUser.lastname;
    trk.trackingnumber = this.currentUser.email;
    this.trackingservice.createTracking(trk).subscribe(resp => { });
    // CHANGE DISPATCH ORDER STATE
    this.dispatchorderservice.changeState(this._dispatchOrder.id, 6).subscribe(resp => {
      this.dispatchorderservice.getDispatchOrder(resp.id).subscribe(resp => {
        this._dispatchOrder = resp;
        this._machines = resp.machines;
        this._trackings = resp.trackings;
        this._date = this.datePipe.transform(resp.date, "dd-MM-yyyy");
        this._time = this.datePipe.transform(resp.date, 'h:mm:ss a');
        this._state = resp.dispatchstate;

        // SEND EMAIL NOTIFICATION
        // this.sendNotification();
        // LOG USER EVENT 
        this.logeventservice.logEventDo(this.currentUser.id, "Receive Order",
          {
            button: 'Confirm Reception',
            result: 'Success',
            page: 'dispatchorder'
          }, this._dispatchOrder.id, null);
        this.showReceive = false;
        //Redirect to Order detail view
        this.reloadPage();
      });
    });

  }


  //  RETURN ORDER OF FIXED DEVICES
  returnOrder() {

    // Set variables if partial or full return
    var dstate = 8;
    var trkstate = 2;
    var eventDetail = "Return Order";

    if (this.inRepairs()) { dstate = 9; trkstate = 5; eventDetail = "Partial Return" }

    var trk: TrackingCreate = new TrackingCreate;
    var timestamp = new Date();
    trk.date = timestamp;
    trk.trackingstate = trkstate;
    trk.dispatchorder = this._dispatchOrder.id;
    this.getCurrentUser();
    trk.user = this.currentUser.id;
    trk.shipper = this.currentUser.firstname + " " + this.currentUser.lastname;
    trk.trackingnumber = this.currentUser.email;
    this.trackingservice.createTracking(trk).subscribe(resp => { });
    this.dispatchorderservice.changeState(this._dispatchOrder.id, dstate).subscribe(resp => {
      this.dispatchorderservice.getDispatchOrder(resp.id).subscribe(resp => {
        this._dispatchOrder = resp;
        this._machines = resp.machines;
        this.updateMachineDispatch(this._machines);
        this._trackings = resp.trackings;
        this._date = this.datePipe.transform(resp.date, "dd-MM-yyyy");
        this._time = this.datePipe.transform(resp.date, 'h:mm:ss a');
        this._state = resp.dispatchstate;
        var retBtn = document.getElementById("returnBtn");
        retBtn.style.display = "none";
        // SEND EMAIL NOTIFICATION 
        //this.sendNotification();
        // LOG USER EVENT 
        this.logeventservice.logEventDo(this.currentUser.id, eventDetail,
          {
            button: 'Return Order',
            result: 'Success',
            page: 'dispatchorder'
          }, this._dispatchOrder.id, null);
        this.reloadPage();
      });
    });
  }

  //  CLIENT ACCEPT RETURN OF FIXED DEVICES
  acceptOrder() {
    var dstate = 7;
    var trkstate = 4;
    var eventDetail = "Accept Return"
    if (this._dispatchOrder.dispatchstate.id == 9) { dstate = 10; eventDetail = "Partial Return"; trkstate = 5 };
    this.showAccept = false;
    var trk: TrackingCreate = new TrackingCreate;
    var timestamp = new Date();
    trk.date = timestamp;
    trk.trackingstate = trkstate;
    trk.dispatchorder = this._dispatchOrder.id;
    this.getCurrentUser();
    trk.user = this.currentUser.id;
    trk.shipper = this.currentUser.firstname + " " + this.currentUser.lastname;
    trk.trackingnumber = this.currentUser.email;
    this.trackingservice.createTracking(trk).subscribe(resp => { });
    this.dispatchorderservice.changeState(this._dispatchOrder.id, dstate).subscribe(resp => {
      this.dispatchorderservice.getDispatchOrder(resp.id).subscribe(resp => {
        this._dispatchOrder = resp;
        this._machines = resp.machines;
        this._trackings = resp.trackings;
        this._date = this.datePipe.transform(resp.date, "dd-MM-yyyy");
        this._time = this.datePipe.transform(resp.date, 'h:mm:ss a');
        this._state = resp.dispatchstate;

        // SEND EMAIL NOTIFICATION 
        this.sendCustomNotification("Dispatch Order " + this._dispatchOrder.id +
          " was received and accepted.", "Dispatch Order " + this._dispatchOrder.dispatchstate.state);

        // LOG USER EVENT 
        this.logeventservice.logEventDo(this.currentUser.id, eventDetail,
          {
            button: 'Accept Order',
            result: 'Success',
            page: 'dispatchorder'
          }, this._dispatchOrder.id, null);
        this.reloadPage();
      }

      );
    });

  }

  //  GET CURRENT USER FORM SESSION COOKIE
  getCurrentUser() {
    try {
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      if (this.auth != null) {
        this.currentUser = this.auth.user;
      }
      else
        this.currentUser = null;
      return false;
    }
    catch (e) {
      console.log("we caught an error!!" + e);
      return false;
    }
  }


  //  SEND EMAIL NOTIFICATION
  sendNotification() {
    var ml = new ML();
    ml.content = "We have a new order to process. Details:  " + this._dispatchOrder.details.replace(/<[^>]+>/g, '');
    ml.subject = "Dispatch Order Confirmation";
    ml.sender = this.currentUser.firstname + " " + this.currentUser.lastname;
    ml.senton = new Date;
    ml.senderemail = this.currentUser.email;
    ml.receipientemail = "issam.khatib@k2ss.fr"
    this.sendgridservice.sendMail(ml).subscribe(any => { });
  }


  //  SEND EMAIL NOTIFICATION
  sendCustomNotification(content: string, subject: string) {
    var ml = new ML();
    ml.content = content;
    ml.subject = subject
    ml.sender = this.currentUser.firstname + " " + this.currentUser.lastname;
    ml.senton = new Date;
    ml.senderemail = this.currentUser.email;
    ml.receipientemail = "issam.khatib@k2ss.fr"
    this.sendgridservice.sendMail(ml).subscribe(any => { });
  }


  // Remove Machine from Array
  async remove(index, serialnum, macId) {
    if (this._state.state == "Open") {
      if (confirm("Are you sure to remove this device?")) {
        await this.dispatchitemservice.removeDispatchItem(index).subscribe(resp => {

          // Dispatch = FALSE
          this._machineservice.changeDispatch(macId, false).subscribe();
          // Set Machine State to Working
          this._machineservice.changeState(macId, 1).subscribe()
          // Delete Ticket 
          this.ticketservice.deleteTicket(resp.ticket.id).subscribe();
          // LOG USER EVENT 
          this.logeventservice.logEventDo(this.currentUser.id, "Remove Device => Not Received",
            {
              button: 'Remove',
              result: 'Success',
              page: 'dispatchorder',
              machine: serialnum
            }, this._dispatchOrder.id, null);
          this.ngOnInit();
        });
      }
    }
    if (this._state.state == "In Progress") {

      // Set Machine State to Working
      this._machineservice.changeState(macId, 7).subscribe()

      // LOG USER EVENT 
      this.logeventservice.logEventDo(this.currentUser.id, "Remove Device => In Repairs",
        {
          button: 'Remove',
          result: 'Success',
          page: 'dispatchorder',
          machine: serialnum
        }, this._dispatchOrder.id, null);
      this.ngOnInit();
    }
  }


  // SEARCH OPTION TO VALIDATE RECEIVED DEVICES
  search(searchquery) {
    try {
      var row = document.getElementById(searchquery);
      row.style.backgroundColor = 'lightgreen';
    }
    catch (e) {
      window.alert("Warning Device not listed in the Dispatch Order");
      console.log(e);
      if (this._userRole == "Authenticated" || this._userRole == "Administrator") {
        this._machineservice.getMachineByCriteriaAdmin('serialnumber', searchquery, environment.token).subscribe(machines => {
          if (this._newMachines == null) {

            if (machines[0].client.id != this._dispatchOrder.client.id) {
              window.alert("The device is not for the same client. You may not enter it in this dispatch order. ")

            }
            else {
              this._newMachines = machines;
              var tempItem: DispatchItem = new DispatchItem;
              tempItem.fixcats = [];
              tempItem.machine = machines[0];
              this._newDispatchItems.push(tempItem);
            }
          }
          else {
            if (machines[0].client.id != this._dispatchOrder.client.id) {
              window.alert("The device is not for the same client. You may not enter it in this dispatch order. ")

            }
            else {
              this._newMachines.push(machines[0]);
              var tempItem: DispatchItem = new DispatchItem;
              tempItem.fixcats = [];
              tempItem.machine = machines[0];
              this._newDispatchItems.push(tempItem);
            }
          }
        }
        );
      }
    }
  }

  // Loop thru all Machines in Dispatch and set State to False
  updateMachineDispatch(machines: Machine[]) {
    try {
      machines.forEach((machine, index) => {
        if (machine.state.statevalue != "In Repairs") {
          this._machineservice.changeDispatch(machine.id, false).subscribe();
        }
      });
    } catch (error) {


    }
  }


  // ADD ITEM FROM ORDER IN CASE ADDITIONAL NON REGISTERED ITEM
  addItem(newItem: DispatchItem) {
    try {
      var tempDoItems: DispatchItem[] = this._dispatchItems;
      tempDoItems.push(newItem);
      newItem.dispatchorder = this._dispatchOrder.id;
      this._dispatchOrder.orderitems = tempDoItems;
      this.dispatchitemservice.createDispatchItem(newItem).subscribe(resp => {
        // CREATE TICKETS FOR EACH ORDER ITEM
        var templength = resp.fixcats.length;
        this._newticket = new TicketCreate;
        this._newticket.title = resp.machine.shortname + " Repair";
        this._newticket.status = 1;
        this._newticket.machines = resp.machine.id;
        this._machineservice.changeState(newItem.machine.id, 2).subscribe();
        this._newticket.details = "<figure class=\"table\"><table><tbody><tr><td><strong>Repair ITEM&nbsp;</strong></td><td><strong>Desctiption</strong></td></tr>"
        var j = 0
        // CREATE TABLE OF FIX CATEGORIES   
        while (j < templength) {
          this._newticket.details = this._newticket.details + "<tr><td>" + (j + 1) + "</td><td>" + resp.fixcats[j].cat + "</td></tr>"
          // CHECK IF LAST RECORD AND CREATE TICKET
          if (j == templength - 1) {
            this._newticket.details = this._newticket.details + "</tbody></table></figure>"
            this._newticket.user = this._userId;
            this._newticket.client = resp.dispatchorder.client;
            this._newticket.errorcode = resp.machine.shortname + " Repair";
            var timestamp = new Date();
            this.datePipe.transform(timestamp, "yyy-MM-dd");
            this._newticket.dateofticket = timestamp;
            this._newticket.dateresolved = timestamp;
            //  this._newticket.fixcat = this._fid[i];
            this._newticket.dispatchorder = this._dispatchOrder.id;
            this.ticketservice.createTicket(this._newticket).subscribe();
          }
          j++;
        }
        // LOG USER EVENT 
        this.logeventservice.logEventDo(this.currentUser.id, "Add Device",
          {
            button: 'Add',
            result: 'Success',
            page: 'dispatchorder',
            machine: resp.machine.serialnumber
          }, this._dispatchOrder.id, null);
        this._newDispatchItems = null;
        this.reloadPage();
      }
      );
    } catch { }
  }


  // SETS THE SHOW OR HIDDEN BUTTONS
  setMenu(dsid: number, id: string) {

    // VERSYS ADMINISTRATIVE USER
    if (id == "1") {

      // IF STATE IS OPEN AND READY TO BE RECEIVED
      if (dsid == 3) {
        this.showReceive = true;
        this.showAdd = true;
        this.showRemove = true;
        this._editnote = true;
      }
      // IF STATE IS RECEIVED AND READY TO BE RETURNED
      if (dsid == 6 || dsid == 9 || dsid == 10) {
        this.showReturn = true;
        this.showRemove = true;
        this._editnote = true;
      }
    }
    //VERSYS TECH SUPPORT USER
    if (id == "2") {
    }
    // CLIENT ACCOUNT AND STATE IS RETURNED TO BE ACCEPTED
    if (id == "3" && (dsid == 8 || dsid == 9)) {
      this.showAccept = true;
    }
  }

  // SAVE NOTE TO DISPATCH ORDER
  save_note() {
    try {
      this.dispatchorderservice.saveNote(this._dispatchOrder.id, this._dispatchOrder.note).subscribe(
        resp => {
          if (resp != undefined) {
            window.alert("Note Saved.")
          } else { window.alert("Error. Save failed.") }
        });
    }
    catch {

    }
  }

  // CHECK IF ANY MACHINES ARE STILL IN REPAIRS AND RETURN TRUE OR FALSE
  inRepairs(): boolean {
    try {
      return this._machines?.some(machine => machine.state?.statevalue === "In Repairs") || false;
    } catch {
      return false;
    }
  }


  checkRepairs() {
    console.log("THERE ARE MACHINES IN REPAIR = " + this.inRepairs());
  }
}
